import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '@types-lib';
import { ClinicEnvironment, ENVIRONMENT } from 'environments';

export class MfaMethodSelectionEndpoint {
  private env = inject<ClinicEnvironment>(ENVIRONMENT);
  httpClient = inject(HttpClient);

  post(methodSelectionRequest: Auth.MfaMethodSelectionRequest) {
    return this.httpClient
      .post<Auth.MfaMethodSelectionResponse>(`${this.env.constants.serverless_tracking_api_url}mfa/send/code`, methodSelectionRequest)
  }
}
